'use client';

import { c as _c } from "react/compiler-runtime";
import BaseSpinner from '@module/components/Spinner/BaseSpinner';
import Tag from '@module/components/Tag/Tag';
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useNoticeListViewModel from '@module/helpers/channel/notice/useNoticeListViewModel';
import { aspCond } from '@module/helpers/conditions/condition';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { BaseRightArrow } from '@module/svg/icons';
import { convertISOToDottedShortDateString } from '@module/utils/date/convertDateFormat';
import { getTimeDifferenceTodayOnly } from '@module/utils/getTimeDifference';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import SimpleNoticeCard from '@pc/components/card/SimpleNoticeCard';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import BaseTooltip from '@pc/components/tooltip/BaseTooltip';
import { Separator } from '@pc/components/ui/separator';
import { useParams } from 'next/navigation';
function NoticeListContainer() {
  const $ = _c(35);
  const params = useParams();
  const channelId = params?.id ? decodeURIComponent(params.id) : "";
  const {
    isLogin,
    userInfo
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore(_temp);
  const {
    noticeList,
    isMyChannel,
    currentPage,
    setCurrentPage,
    isNoticeListLoading,
    isListEmpty,
    showNoticeEditModal,
    showNoticeDeleteConfirmModal,
    showDeleteVoteConfirmModal,
    handleReportClick,
    showNoticeWriteModal,
    showNoticInfoModal,
    showVoteModal
  } = useNoticeListViewModel(channelId);
  let t0;
  if ($[0] !== isMyChannel || $[1] !== showNoticeWriteModal || $[2] !== showVoteModal || $[3] !== userInfo?.globalBJYN) {
    t0 = isMyChannel && <>{userInfo?.globalBJYN === "Y" && !SettingConfig.isProd && <SimpleNoticeCard content={"\uAE00\uB85C\uBC8C \uD68C\uC6D0\uC758 \uCC44\uB110\uC5D0\uB3C4 BJ\uC54C\uB9BC\uC744 \uAC8C\uC2DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."} />}<div className="mb-6 flex justify-end">{userInfo?.globalBJYN === "Y" && !SettingConfig.isProd && <BaseTooltip escapeOverflow={true} containerClassName="mr-4" tipClassName="font-normal" content={<div className="w-[340px] whitespace-pre-wrap px-[15px] py-[10px]">{"\uC54C\uB9BC\uAE00 \uC55E\uC758 \uC544\uC774\uCF58\uC744 \uD1B5\uD574 BJ\uC54C\uB9BC\uC774 \uB4F1\uB85D\uB41C \uCC44\uB110\uC774 \uAD6C\uBD84\uB429\uB2C8\uB2E4. \n\uAE00\uB85C\uBC8C: \uAE00\uB85C\uBC8C \uD68C\uC6D0\uC774 \uBCF4\uB294 \uCC44\uB110\uC5D0 \uB4F1\uB85D\uB41C BJ\uC54C\uB9BC \n\uD55C\uAD6D : \uD55C\uAD6D \uD68C\uC6D0\uC774 \uBCF4\uB294 \uCC44\uB110\uC5D0 \uB4F1\uB85D\uB41C BJ\uC54C\uB9BC"}</div>} iconSize={20} />}<BaseButton throttleDelay={1000} className="mr-3 h-[48px] rounded-[8px] px-5 text-[17px]" onClick={() => showVoteModal()}><span className="mr-3">투표</span><BaseRightArrow style={{
            color: "var(--colorFg04)",
            fontSize: 6
          }} /></BaseButton><BaseButton throttleDelay={1000} className="h-[48px] rounded-[8px] px-5 text-[17px]" onClick={() => showNoticeWriteModal()}><span className="mr-3">작성하기</span><BaseRightArrow style={{
            color: "var(--colorFg04)",
            fontSize: 6
          }} /></BaseButton></div></>;
    $[0] = isMyChannel;
    $[1] = showNoticeWriteModal;
    $[2] = showVoteModal;
    $[3] = userInfo?.globalBJYN;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator className="bg-borderBg03" />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== handleReportClick || $[7] !== isLogin || $[8] !== isMyChannel || $[9] !== noticeList?.list || $[10] !== pushModal || $[11] !== showDeleteVoteConfirmModal || $[12] !== showNoticInfoModal || $[13] !== showNoticeDeleteConfirmModal || $[14] !== showNoticeEditModal || $[15] !== showVoteModal || $[16] !== userInfo?.globalBJYN) {
    t2 = noticeList?.list.map(item => {
      const timeDifference = getTimeDifferenceTodayOnly(item.insertDateTime);
      let uploadedTime = null;
      if (typeof timeDifference !== "string") {
        if (timeDifference.i18nKey === "justNow") {
          uploadedTime = "\uBC29\uAE08 \uC804";
        } else {
          if (timeDifference.i18nKey === "nMinutesAgo") {
            uploadedTime = `${timeDifference.number}분 전`;
          } else {
            if (timeDifference.i18nKey === "nHoursAgo") {
              uploadedTime = `${timeDifference.number}시간 전`;
            } else {
              if (timeDifference.i18nKey === "yesterday") {
                uploadedTime = convertISOToDottedShortDateString(item.insertDateTime);
              }
            }
          }
        }
      }
      if (!uploadedTime) {
        uploadedTime = convertISOToDottedShortDateString(item.insertDateTime);
      }
      const isVote = !!item.voteIdx;
      const isGlobal = !!item.isGlobal;
      return <div className="mt-6 border-b-[1px] border-b-borderBg03 pb-6" key={item.idx}><div onClick={() => {
          if (isVote) {
            if (!isLogin) {
              if (aspCond.if("new-asp")) {
                SettingConfig.aspUtils?.goLogin();
                return;
              }
              pushModal({
                type: "AUTH_MODAL",
                id: "NoticeListContainer"
              });
              return;
            }
            showVoteModal(item.voteIdx);
          } else {
            showNoticInfoModal(item.imgMainSrc, item.contents);
          }
        }} className="flex min-h-[150px] w-full cursor-pointer items-center justify-between"><div className={cn("flex w-full max-w-full flex-col items-start justify-between", {
            "max-w-[1080px]": !!item.imgMainSrc
          })}>{(item.isTop || item.voteStat === "success" || item.voteStat === "end") && <div className="mb-3 flex items-center gap-2">{item.isTop && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/notice_top.png`} alt="top" className="h-[28px]" />}{item.voteStat === "success" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/vote_proceeding.png`} alt="ing" className="h-[28px]" />}{item.voteStat === "end" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/vote_end.png`} alt="ing" className="h-[28px]" />}</div>}<div className="mb-[15px] w-full pr-5 text-colorFg04"><div className="flex items-start gap-2">{userInfo?.globalBJYN === "Y" && isMyChannel && isGlobal && <Tag.Root className="mt-[1px] bg-tag-global"><Tag.Label className="text-[10px] text-system-white">글로벌</Tag.Label></Tag.Root>}<div className="line-clamp-2 h-[50px] overflow-hidden text-ellipsis break-all align-middle"><div dangerouslySetInnerHTML={{
                    __html: item.contents
                  }} /></div></div></div><p className="mb-[30px] text-[#777] leading-[1]">{uploadedTime}</p>{isMyChannel && <div className="flex gap-2"><BaseButton size="sm" onClick={() => {
                if (isVote) {
                  showVoteModal(item.voteIdx);
                } else {
                  showNoticeEditModal(item.idx, item.contents, item.imgMainSrc, item.isGlobal, item.isTop);
                }
              }}>수정</BaseButton><BaseButton size="sm" onClick={() => {
                if (isVote) {
                  showDeleteVoteConfirmModal(item.voteIdx);
                } else {
                  showNoticeDeleteConfirmModal(item.idx);
                }
              }}>삭제</BaseButton>{userInfo?.globalBJYN === "Y" && !isVote && isGlobal && <BaseButton size="sm" onClick={() => {
                showNoticInfoModal(item.imgMainSrc, item.contentsJa || "", isGlobal);
              }}>번역보기</BaseButton>}</div>}{!isMyChannel && !isVote && <BaseButton size="sm" className="min-w-[60px] text-[15px]" onClick={() => handleReportClick(item.idx, item.contents)}>신고</BaseButton>}</div>{item.imgMainSrc && <div className="h-[134px] w-[240px] min-w-[240px] rounded-lg"><img src={item.imgMainSrc} alt="preview" className="h-[134px] w-[240px] rounded-lg object-cover" /></div>}</div></div>;
    });
    $[6] = handleReportClick;
    $[7] = isLogin;
    $[8] = isMyChannel;
    $[9] = noticeList?.list;
    $[10] = pushModal;
    $[11] = showDeleteVoteConfirmModal;
    $[12] = showNoticInfoModal;
    $[13] = showNoticeDeleteConfirmModal;
    $[14] = showNoticeEditModal;
    $[15] = showVoteModal;
    $[16] = userInfo?.globalBJYN;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== isListEmpty || $[19] !== isMyChannel) {
    t3 = isListEmpty && <NotFoundDisplay text={isMyChannel ? "\uD68C\uC6D0\uB2D8\uC758 BJ \uC54C\uB9BC\uC774 \uC5C6\uC5B4\uC694.\n\uC54C\uB9BC\uC744 \uB4F1\uB85D\uD558\uC5EC \uB098\uB9CC\uC758 \uC54C\uB9BC\uC744 \uB9CC\uB4E4\uC5B4 \uBCF4\uC138\uC694!" : "\uC791\uC131\uB41C BJ\uC54C\uB9BC\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."} className="mt-10" />;
    $[18] = isListEmpty;
    $[19] = isMyChannel;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== isNoticeListLoading) {
    t4 = isNoticeListLoading && <div className="mt-10 flex h-[280px] items-center justify-center"><BaseSpinner size={40} /></div>;
    $[21] = isNoticeListLoading;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  const t5 = noticeList?.page;
  let t6;
  if ($[23] !== currentPage || $[24] !== setCurrentPage || $[25] !== t5) {
    t6 = <div className="mt-[30px]"><BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={t5} /></div>;
    $[23] = currentPage;
    $[24] = setCurrentPage;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t6) {
    t7 = <div>{t1}{t2}{t3}{t4}{t6}</div>;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t0 || $[33] !== t7) {
    t8 = <>{t0}{t7}</>;
    $[32] = t0;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8;
}
function _temp(state) {
  return state;
}
export default NoticeListContainer;